import React, { useState } from "react";
import { useStyles } from "./modalContent";

const AssignRoleModal = ({ isOpen, onClose, user, roles, onAssign }) => {
  const classes = useStyles();
  const [selectedRoleId, setSelectedRoleId] = useState("");
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setSelectedRoleId(e.target.value);
    setError(null);
  };

  const handleSubmit = async () => {
    if (!selectedRoleId) {
      setError("Please select a role.");
      return;
    }
    try {
      await onAssign(user.id, selectedRoleId);
      onClose();
    } catch (err) {
      setError("Failed to assign role. Please try again.");
    }
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "1000",
      }}
    >
      <div
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "8px",
          width: "400px",
          boxShadow: "0 8px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <h2>
          Assign Role to {user?.first_name} {user?.last_name}
        </h2>
        {error && <p style={{ color: "red" }}>{error}</p>}
        <form>
          <div>
            <label className={classes.enroleeIdText}>Select Role:</label>
            <select
              name="role_id"
              value={selectedRoleId}
              onChange={handleChange}
              className={classes.enroleeInputId}
              style={{ width: "100%", padding: "8px", marginTop: "8px" }}
            >
              <option value="">Select a role</option>
              {roles.map((role) => (
                <option key={role.id} value={role.id}>
                  {role.name}
                </option>
              ))}
            </select>
          </div>
        </form>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            marginTop: "20px",
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "8px 16px",
              background: "#ccc",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            style={{
              padding: "8px 16px",
              background: "#1976d2",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Assign
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssignRoleModal;
